var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgInputClose = function SvgInputClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#696F7F",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.085 2.915c-3.888-3.887-10.282-3.887-14.17 0-3.887 3.888-3.887 10.282 0 14.17 3.888 3.887 10.282 3.887 14.17 0 3.887-3.888 3.887-10.157 0-14.17Z",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.072 14.075 9.937 10.94l-3.134 3.135a.606.606 0 0 1-.878 0 .606.606 0 0 1 0-.878l3.135-3.134-3.135-3.135a.606.606 0 0 1 0-.878c.25-.25.627-.25.878 0l3.134 3.135 3.135-3.135c.25-.25.627-.25.878 0 .25.25.25.627 0 .878l-3.135 3.135 3.135 3.134c.25.251.25.627 0 .878a.606.606 0 0 1-.878 0Z"
  }))));
};
export default SvgInputClose;